import request from "@/utils/request";
export function domainConfigFromNode(data) {
  const params = {
      header: {},
      content: data
  }
  return request({
      url: '/portal-config/domainConfigFromNode',
      method: 'post',
      data: params
  })
}